<template>
  <div>
    <FieldWatch
      :showFieldWatchModal="showFieldWatchModal"
      :units="units"
      :field="field"
      :fieldValues="fieldValues"
      :selectedProduct="selectedProduct"
      :comment="commentToShow"
      @update="updateModal"
    ></FieldWatch>

    <ProductWatch
      :product="selectedProduct"
      :showProductWatchModal="showProductWatchModal"
      :units="units"
      :comment="commentToShow"
      @update="updateModal"
    >
    </ProductWatch>

    <CategoryWatch
      :category="category"
      :showCategoryModal="showCategoryWatchModal"
      :languages="languages"
      :comment="commentToShow"
      @update="updateModal"
    ></CategoryWatch>

    <CancelModal
      :action="action"
      :showRejectModal="showCancelModal"
      @update="updateModal"
    ></CancelModal>
  </div>
</template>

<script>
import FieldWatch from "@/views/allLogic/modals/field/watch";
import ProductWatch from "@/views/allLogic/modals/product/watch";
import CategoryWatch from "@/views/allLogic/modals/category/watch";
import CancelModal from "@/views/validateAction/requestView/rejectModal";
import { GET } from "@/shared/api";

export default {
  components: { FieldWatch, ProductWatch, CategoryWatch, CancelModal },
  props: {
    actions: [],
    showWatchModal: false,
    modalData: {
      route: null,
      index: null,
    },
  },
  data() {
    return {
      showCancelModal: false,
      showFieldWatchModal: false,
      showProductWatchModal: false,
      showCategoryWatchModal: false,
      action: {},
      category: {},
      product: {},
      field: {},
      fieldValues: [],
      selectedProduct: {
        code: null,
        title: null,
      },
      units: [],
      languages: [],
    };
  },
  watch: {
    modalData: {
      handler: "openModal",
    },
  },
  computed: {
    commentToShow() {
      if (
        this.modalData &&
        this.modalData.status === 2 &&
        this.modalData.comment
      ) {
        return this.modalData.comment;
      }
      return null;
    },
  },
  methods: {
    updateParent(state, event = "update") {
      this.$emit(event, state);
    },
    updateModal(state) {
      if (typeof state === "object" && state.modal) {
        switch (state.modal) {
          case "field":
            this.showFieldWatchModal = state.visible;
            break;
          case "product": {
            this.showProductWatchModal = state.visible;
            break;
          }
          case "category": {
            this.showCategoryWatchModal = state.visible;
            break;
          }
          case "cancel": {
            this.showCancelModal = state.visible;
            if (typeof state.getAA === "boolean" && state.getAA)
              this.updateParent({ action: "gAA" });
            break;
          }
        }
      }
      // this.$emit('update', state.visible);
    },
    openModal({ route, index }) {
      if (Array.isArray(route)) {
        switch (route[0]) {
          case "field":
            {
              switch (route[1]) {
                case "destroy":
                  this.getField(this.actions[index].request_data.id);
                  break;
                default:
                  this.field = this.actions[index].request_data.request;
                  if (Array.isArray(this.field.translations)) {
                    this.field.translations.forEach((el) => {
                      if (el.locale && el.locale === "ru") {
                        el.title = this.field.title;
                        el.comment = this.field.comment;
                      }
                    });
                  }
                  this.fieldValues = this.field.values;
                  this.getProduct(this.field.product_id);
              }

              this.showFieldWatchModal = true;
            }
            break;
          case "product":
            {
              switch (route[1]) {
                case "destroy":
                  this.getProduct(this.actions[index].request_data.id);
                  break;
                default:
                  this.selectedProduct =
                    this.actions[index].request_data.request;
                  if (this.selectedProduct.translations) {
                    this.selectedProduct.translations.forEach((el) => {
                      if (el.locale && el.locale === "ru") {
                        el.title = this.selectedProduct.title;
                      }
                    });
                  }
                  if (
                    this.selectedProduct.title == null &&
                    typeof this.selectedProduct.ru_title == "string"
                  ) {
                    this.selectedProduct.title = this.selectedProduct.ru_title;
                  }
              }
              this.showProductWatchModal = true;
            }
            break;
          case "category":
            {
              switch (route[1]) {
                case "destroy":
                  this.getCategory(this.actions[index].request_data.id);
                  break;
                default:
                  this.category = this.actions[index].request_data.request;
                  if (this.category.translations) {
                    this.category.translations.forEach((el) => {
                      if (el.locale && el.locale === "ru") {
                        el.title = this.category.title;
                      }
                    });
                  }
              }
              this.showCategoryWatchModal = true;
            }
            break;
          case "cancel":
            {
              this.action = this.actions[index];
              this.showCancelModal = true;
            }
            break;

          default:
            console.log("default open model");
        }
      }
    },
    getCategory(id) {
      GET([], "/category/" + id, this, false).then((response) => {
        this.category = response;
      });
    },
    getProduct(id) {
      GET([], "/product/" + id, this, false).then((response) => {
        this.selectedProduct = response;
      });
    },
    getField(id) {
      this.fieldValues = [];
      GET([], "/field/query/" + id + "?mode=def", this, false).then(
        (response) => {
          this.field = response;
          this.field.ru_title = response.title;
          this.field.ru_comment = response.comment;
          this.getProduct(this.field.product_id);

          if (this.field.inputType === "range") {
            response.values.forEach((val) => {
              val.value = JSON.parse(val.value);
              delete val.translations;
              this.fieldValues.push(val);
            });
          } else {
            response.values.forEach((val) => {
              delete val.translations;
              this.fieldValues.push(val);
            });
          }
        }
      );
    },
    getUnits() {
      GET([], "/unit", this, false).then((response) => {
        this.units = response;
      });
    },
    getLanguages() {
      GET([], "/language", this, false).then((response) => {
        this.languages = response;
      });
    },
  },
  mounted() {
    this.getUnits();
    this.getLanguages();
    console.log("modalData", this.$props.modalData);
  },
};
</script>

<style scoped></style>
